import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {IconButton, ListItemIcon, ListItemText} from "@mui/material";
import {InfoRounded} from "@mui/icons-material";

export default function GeneralMenu({items,onChange}) {


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >

                {items.map(v=><MenuItem onClick={(event) => {
                    event.stopPropagation();
                    handleClose();
                    if (onChange && typeof onChange === 'function') {
                        onChange(v.value);
                    }
                }}>
                    <ListItemIcon>
                        <InfoRounded fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>{v.label}</ListItemText>
                </MenuItem>)}

            </Menu>
        </div>
    );
}